var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscription-info"},[_vm._v("asd")])}
var staticRenderFns = []

export { render, staticRenderFns }